/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_Superset_Linked_ToastInputs */

const en_us2_plan_edit_superset_linked_toast = /** @type {(inputs: Plan_Edit_Superset_Linked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset created: one set of each, then the rest`)
};

const pt_br2_plan_edit_superset_linked_toast = /** @type {(inputs: Plan_Edit_Superset_Linked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset criado: uma série de cada, depois o descanso`)
};

const es_419_plan_edit_superset_linked_toast = /** @type {(inputs: Plan_Edit_Superset_Linked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superserie creada: una serie de cada uno y luego el descanso`)
};

const pt_pt2_plan_edit_superset_linked_toast = /** @type {(inputs: Plan_Edit_Superset_Linked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset criado: uma série de cada, depois o descanso`)
};

const fr_fr2_plan_edit_superset_linked_toast = /** @type {(inputs: Plan_Edit_Superset_Linked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset créé : une série de chaque, puis le repos`)
};

const de_de2_plan_edit_superset_linked_toast = /** @type {(inputs: Plan_Edit_Superset_Linked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supersatz erstellt: je ein Satz, dann die Pause`)
};

const it_it2_plan_edit_superset_linked_toast = /** @type {(inputs: Plan_Edit_Superset_Linked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset creato: una serie di ciascuno, poi il recupero`)
};

/**
* | output |
* | --- |
* | "Superset created: one set of each, then the rest" |
*
* @param {Plan_Edit_Superset_Linked_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_superset_linked_toast = /** @type {((inputs?: Plan_Edit_Superset_Linked_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Superset_Linked_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_superset_linked_toast(inputs)
	if (locale === "es-419") return es_419_plan_edit_superset_linked_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_superset_linked_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_superset_linked_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_superset_linked_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_superset_linked_toast(inputs)
	return en_us2_plan_edit_superset_linked_toast(inputs)
});
export { plan_edit_superset_linked_toast as "plan-edit.superset_linked_toast" }